import React from 'react'
interface RadioButtonProps {
  value: string
  checked: boolean
  onChange: (value: string) => void
}

// Inline SVG instead of <Image> or plain <img>. Even plain <img> hit React 19
// #418 — SSR emitted `<img src="..." width="20" height="20" alt="...">` (src
// first) while CSR DOM normalized to `<img width="20" height="20" alt="..."
// src="...">` (src reordered to last). Confirmed via at-error
// captureHydrationDiff on /renta-bodegas-comerciales/* listing pages (Chrome
// 148 Desktop, Megacable Mexico, 2026-05-28). Inline SVG has no `src`, no
// next/image style injection, no attribute-order surface — deterministic on
// both server and client. Same Pass 5 fix documented for the SpotMe logo.
const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g>
      <path
        d="M7.55689 13.9705L4.75162 11.1644C4.62294 11.0359 4.52085 10.8832 4.4512 10.7151C4.38155 10.5471 4.3457 10.367 4.3457 10.185C4.3457 10.0031 4.38155 9.82301 4.4512 9.65497C4.52085 9.48692 4.62294 9.33424 4.75162 9.20567C5.0115 8.94617 5.36375 8.80042 5.731 8.80042C6.09826 8.80042 6.4505 8.94617 6.71038 9.20567L8.46721 10.9609C8.50262 10.9961 8.55054 11.0159 8.60048 11.0159C8.65043 11.0159 8.69834 10.9961 8.73376 10.9609L13.2894 6.40525C13.5493 6.14575 13.9015 6 14.2688 6C14.636 6 14.9883 6.14575 15.2481 6.40525C15.3768 6.53382 15.4789 6.6865 15.5486 6.85455C15.6182 7.02259 15.6541 7.20272 15.6541 7.38463C15.6541 7.56654 15.6182 7.74667 15.5486 7.91471C15.4789 8.08276 15.3768 8.23543 15.2481 8.36401L9.64246 13.9705C9.36587 14.247 8.99078 14.4024 8.59967 14.4024C8.20857 14.4024 7.83348 14.247 7.55689 13.9705Z"
        fill="#00A4FF"
      />
      <circle cx="10" cy="10" r="9.5" stroke="#00A4FF" />
    </g>
  </svg>
)

const RadioButton: React.FC<RadioButtonProps> = ({
  value,
  checked,
  onChange
}) => {
  return (
    <button
      type="button"
      className={`flex w-full items-center rounded-[10px] text-[15px] md:w-[133px] ${
        checked
          ? 'justify-between border border-blue-500 bg-white-500 text-blue-500'
          : 'bg-grey-300 text-black-500'
      } px-3 py-[10px]`}
      onClick={() => onChange(value)}
    >
      {value}
      {checked && <CheckIcon />}
    </button>
  )
}

export default RadioButton
